module.exports = __webpack_public_path__ + "static/media/GaliciaWhite.732d7abb.svg";